//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { parseTime } from "@/utils";
import SalesCard from "@/components/SalesCard";
import DiamondsPopover from "@/components/DiamondsPopover";
export default {
  props: {
    name: String,
    // date: Date,
    info: {
      type: Object,
      required: true,
    },
    isShop: { type: Boolean, default: false },
    active: Number,
  },
  components: { SalesCard, DiamondsPopover },
  data() {
    return {};
  },
  computed: {
    isOperate() {
      return this.$route.name === "Operate";
    },
    tabs() {
      const type = this.isShop ? "shop" : "operate";
      return [
        {
          icon: require(`assets/${type}/today.png`),
          label: "本日统计",
        },
        {
          icon: require(`assets/${type}/month.png`),
          label: "本月统计",
        },
        {
          icon: require(`assets/${type}/year.png`),
          label: "本年统计",
        },
      ];
    },
    bgStyle() {
      return {
        backgroundImage: `url(${require(`assets/${
          this.isShop ? "shop" : "operate"
        }/city-bg.png`)})`,
      };
    },
  },
  methods: {
    parseTime,
    onChange(index) {
      this.$emit("change", index);
    },
  },
};
